import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import phoneIcon from "../assets/phoneIcon.svg";
import mailIcon from "../assets/mail.png";
import websiteIcon from "../assets/globeIcon.svg";
import CategoryStore from "../store/CategoryStore";
import CountryStore from "../store/CountryStore";
import CardComponent from "./CardComponent";

function Card({ slug, image, title, remarks, categoryProp }) {
  const category = CategoryStore((state) => state.category);
  const country = CountryStore((state) => state.country);
  const setGlobalCategory = CategoryStore((state) => state.setCategory);
  const formattedCountry = country.replace(/\s+/g, "-").toLowerCase();
  const navigate = useNavigate();
  const location = useLocation();

  // async function fetchRemarks() {
  //   try {
  //     const formData = new FormData();
  //     formData.append("company_slug", slug);
  //     const response = await fetch(
  //       "https://elsopro.com/api/get_vendor_detail.php",
  //       {
  //         method: "POST",
  //         body: formData,
  //       }
  //     );
  //     const data = await response.json();
  //     // console.log(data)
  //     if (typeof data[0].remarks === "string") {
  //       const cleanString = data[0].remarks
  //         .replace(/\n/g, " ")
  //         .replace(/\r/g, "")
  //         .replace(/\s+/g, " ")
  //         .trim();

  //       const remarksObject = eval("(" + cleanString + ")");
  //       // console.log(remarksObject)

  //       const componentTypes = remarksObject["Crystalline"];
  //       setRemarks(componentTypes);
  //     } else {
  //       setRemarks(data[0].remarks["Component Types"]);
  //       setPowerRange(data[0].remarks["Power Range(Wp)"]);
  //     }
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  // useEffect(() => {
  //   fetchRemarks();
  // }, []);

  function handleClick() {
    const formattedCountry = country.replace(/\s+/g, "-").toLowerCase();
    const formattedCategory = category.replace(/\s+/g, "-").toLowerCase();
    const encodeSlug = slug.replace(/\//g, "-"); // Replace '/' with '-'

    if (location.pathname === `/${formattedCountry}`) {
      const formattedCategory = categoryProp.replace(/\s+/g, "-").toLowerCase();
      setGlobalCategory(formattedCategory);
      navigate(`/${formattedCountry}/${formattedCategory}/${slug}`, {
        state: { slug },
      });
      return;
    }
    // console.log(formattedCategory, formattedCountry);
    const formattedSlug = encodeSlug.includes('-') ? encodeSlug : `${encodeSlug}-`;
    navigate(`/${formattedCountry}/${formattedCategory}/${formattedSlug}`, {
      state: { slug },
    });
  }

  const [imageError, setImageError] = useState(false);

  return (
    <button
      onClick={handleClick}
      className="flex flex-col bg-white border border-[#D9D9D9] rounded-md shadow-sm w-full sm:w-full max-w-full transition-transform transform hover:scale-105"
    >
      <div className="flex h-36 lg:h-32 xl:h-36 2xl:h-44 overflow-hidden">
        {!imageError ? (
          <img
            src={`https://elsopro.com/vendor_images/images/${image}`}
            alt={title}
            className="w-full h-full object-contain p-4 md:px-1 md:py-4 lg:p-6 xl:p-8"
            onError={() => setImageError(true)}
          />
        ) : (
          <div className={`bg-red-600 rounded-md text-white flex items-center justify-center m-6 px-16`}>
            <span className="text-center font-inter">
              {title[0].toUpperCase()}
            </span>
          </div>
        )}
      </div>

      <div className="flex flex-col flex-grow p-4 sm:pt-0 md:pt-0 lg:pt-0 xl:pt-0 2xl:pt-0 lg:p-6 2xl:p-6 xl:pb-0 2xl:pb-4 text-left">
        {/* <img
          src={panels}
          alt="Panels badge"
          className="my-2 self-start w-12 lg:w-14 xl:w-16 2xl:w-20"
        /> */}
        <div className="my-2 bg-[#EEF1F6] text-[#333D4C] rounded-md text-center py-[2px] w-24 text-sm">
          {categoryProp || (category && category[0].toUpperCase() + category.slice(1))}
        </div>
        <h3 className="text-lg lg:text-lg 2xl:text-xl text-[#111827] mb-2 font-semibold break-words">
          {title}
        </h3>

        <CardComponent/>
        {/* Rating */}
        {/* <div className="flex items-center text-sm lg:text-base xl:text-lg 2xl:text-xl mt-2">
          <img
            src={starIcon}
            alt="Star Icon"
            className="mr-2 w-4 h-4 lg:w-5 lg:h-5 xl:w-6 xl:h-6 2xl:w-5"
          />
          <span>4.6 (7523)</span>
        </div> */}
      </div>
    </button>
  );
}

export default Card;